import { useState } from "react"
import { useAuth } from "@/context/AuthContext"
import { loginUser } from "@/lib/api"

export function useLogin() {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const { setCurrentUser } = useAuth()

  const login = async (email: string, password: string, rememberMe = true) => {
    setLoading(true)
    setError(null)

    try {
      const response = await loginUser(email, password, rememberMe)
      
      if (!response) {
        throw new Error("Invalid credentials")
      }
      
      // Extract user from response (tokens are already stored by loginUser)
      const user = response.user || response
      
      if (!user || !user.id) {
        throw new Error("Invalid user data in response")
      }
      
      setCurrentUser(user)
    } catch (err: any) {
      setError(err.message || "Login failed")
      throw err // Re-throw for the component to handle
    } finally {
      setLoading(false)
    }
  }

  return { login, loading, error, setError }
}